<template>
	  <div class="towel-selection">
    <p class="h3 mb-2 pt-2 pb-4">Voulez-vous ajouter l’option barre sèche serviette ?</p>

    <div class="row two-parts">
      <div class="col-lg-7 pr-md-5">

      	<img class="w-100" :src="require('@/assets/img/serviettes/solaris-barres-'+state.radiator.towelDryers+'.png')">

      </div>
      <div class="col-lg-5 px-4 pt-4">

        <div class="form-check check-base mb-4 pl-0" @click="setDataRad('towelDryers','2')">
          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios1" value="option1" :checked="state.radiator.towelDryers==2">
          <label class="form-check-label" for="exampleRadios1">
          		<div class="radio-check"><i class="far fa-check"></i></div>
             	<p class="mb-0 lead pt-1">Avec 2 barres</p>
          </label>
        </div>
        <div class="form-check check-base mb-4 pl-0" @click="setDataRad('towelDryers','3')">
          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios2" value="option2" :checked="state.radiator.towelDryers==3">
          <label class="form-check-label" for="exampleRadios2">
          		<div class="radio-check"><i class="far fa-check"></i></div>
             	<p class="mb-0 lead pt-1">Avec 3 barres</p>
          </label>
        </div>
        <div class="form-check check-base mb-4 pl-0" @click="setDataRad('towelDryers','0')">
          <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios3" value="option3" :checked="!state.radiator.towelDryers">
          <label class="form-check-label" for="exampleRadios3">
          		<div class="radio-check"><i class="far fa-check"></i></div>
             	<p class="mb-0 lead pt-1">Sans barres sèche serviette</p>
          </label>
        </div>

        <router-link tag="button" :to="{name:'PilotingSelection'}" class="btn mt-4 btn-md btn-primary rounded-pill">
          Étape suivante
        </router-link>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "TowelSelection"
}
</script>

<style scoped>

</style>